import BaseObject from '../../../base/base_object';
import {REGULATION_CODE_TYPES, REGULATION_SUFFIX} from '../regulation_const';
import DefaultRegulation from './default_regulation';
import ItalyRegulation from './italy/italy_regulation';
import DkRegulation from './denmark/dk_regulation';
import SpainRegulation from './spain/spain_regulation';
import SwedenRegulation from "./sweden/sweden_regulation";
import PortugalRegulation from "./portugal/portugal_regulation";
import UKRegulation from './com/uk/uk_regulation';
import RomaniaRegulation from './romania/romania_regulation';
import SHRegulation from "./sh/sh";
import MaltaRegulation from './com/malta/malta_regulation';
import NetherlandsRegulation from './netherlands/netherlands_regulation'
import GibRegulation from './com/gib/gib_regulation';
import NewJerseyRegulation from "./us/new_jersey/new_jersey_regulation";
import DelawareRegulation from "./us/delaware/delaware_regulation";
import GermanyRegulation from "./germany/germany_regulation";
import CanadaOntarioRegulation from "./canada/ontario/canada_ontario_regulation";
import MichiganRegulation from "./michigan/michigan_regulation";

class RegulationFactory extends BaseObject {

	static CLASS = "RegulationFactory";

	_regulations = {};

	init(params) {
		super.init(params);
		this.serviceFactory = params.serviceFactory;
		this.configs = params.configs || {};
	}

	getRegulation(regulationCode) {
		let regulationKey = this._createRegulationKey(regulationCode);
		regulationCode = Number(regulationCode);
		if (!this._regulations[regulationKey]) {
			let regulation = this._createRegulation(regulationCode);
			this._regulations[regulationKey] = regulation;
		}

		return this._regulations[regulationKey];
	}

	_createRegulationKey(regulationCode) {
		let country = '_';
		if(this.serviceFactory.countryService().isNetherlands()) {
			country+= 'nld'
		}

		return regulationCode + country;
	}

	_createRegulation(regulationCode) {
		let regulation = null;
		let regulationCreateParams = Object.assign({
            serviceFactory: this.serviceFactory,
            cssSuffix: REGULATION_SUFFIX[regulationCode]
		}, this.configs);

		switch (regulationCode) {
			case REGULATION_CODE_TYPES.ITALY:
				regulation = ItalyRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.DK:
				regulation = DkRegulation.create(regulationCreateParams);
				break;
            case REGULATION_CODE_TYPES.SPAIN:
                regulation = SpainRegulation.create(regulationCreateParams);
                break;
            case REGULATION_CODE_TYPES.SWEDEN:
                regulation = SwedenRegulation.create(regulationCreateParams);
                break;
			case REGULATION_CODE_TYPES.PORTUGAL:
				regulation = PortugalRegulation.create(regulationCreateParams);
				break;
            case REGULATION_CODE_TYPES.NJ:
                regulation = NewJerseyRegulation.create(regulationCreateParams);
                break;
			case REGULATION_CODE_TYPES.GERMANY:
				regulation = GermanyRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.DELAWARE:
				regulation = DelawareRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.CANADA_ONTARIO:
				regulation = CanadaOntarioRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.MICHIGAN:
				regulation = MichiganRegulation.create(regulationCreateParams);
				break;
            case REGULATION_CODE_TYPES.UK:
                regulation = UKRegulation.create(regulationCreateParams);
                break;
			case REGULATION_CODE_TYPES.ROMANIA:
				regulation = RomaniaRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.SH:
				regulation = SHRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.MALTA:
				regulation = MaltaRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.NETHERLANDS:
				regulation = NetherlandsRegulation.create(regulationCreateParams);
				break;
			case REGULATION_CODE_TYPES.GIB:
			case REGULATION_CODE_TYPES.COM:
				if(this.serviceFactory.countryService().isNetherlands()) {
					regulation = NetherlandsRegulation.create(regulationCreateParams);
				} else {
					regulation = GibRegulation.create(regulationCreateParams);
				}
				break;
			default:
				this.logger.warn(`NO CONFIGURATION FOR REGULATION CODE ${regulationCode}! Using the default one!`);
				regulation = DefaultRegulation.create(regulationCreateParams);
				break;
		}

		return regulation;
	}
}

export default RegulationFactory;